<template>
  <div class="z-border-red" style="margin-bottom: 10px">
    <v-layout>
      <v-flex>
        <div class="ma-2">
          <v-checkbox
            :input-value="isCheck"
            :label="`Order No. ${order.id}`"
            style="display: inline-block; margin: 0"
            @change="assignCb(order.id)"
            color="primary"
            hide-details
          ></v-checkbox>
        </div>
      </v-flex>
      <v-flex>
        <div class="ma-2 text-xs-right">
          <template v-if="order.app == 'facebook'">
            <i class="fab fa-facebook-square" style="color: #3c5a99"></i>
          </template>
          <template v-else-if="order.app == 'line'">
            <i class="fab fa-line" style="color: #00c300"></i>
          </template>
        </div>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
    <v-layout wrap fill-height>
      <v-flex xs12 sm7>
        <div style="border-right: 1px solid #eee; height: 100%">
          <template v-if="typeof orderDetailFormat == 'string'">
            <div class="pa-2">
              <nl2br tag="div" :text="order.productdetail"></nl2br>
            </div>
          </template>
          <template v-else-if="typeof orderDetailFormat == 'object'">
            <template v-for="(order, oindex) in orderDetailFormat">
              <v-layout wrap :key="'order_' + oindex">
                <v-flex sm1 xs2>
                  <div class="ma-2">
                    <v-img :src="order.photourl" aspect-ratio="1" alt class="grey lighten-2">
                      <template v-slot:placeholder>
                        <v-layout fill-height align-center justify-center ma-0>
                          <!-- <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular> -->
                        </v-layout>
                      </template>
                    </v-img>
                  </div>
                </v-flex>
                <v-flex sm7 xs6 style="word-break: break-word">
                  <div class="ma-2">
                    {{ order.name }} x {{ order.quantity }}
                    <template v-if="order.option">({{ order.option }})</template>
                  </div>
                </v-flex>
                <v-flex xs4 class="text-xs-right">
                  <div class="ma-2">฿{{ order.price | decimalFormat }}</div>
                </v-flex>
              </v-layout>
              <v-divider v-if="oindex < orderDetailFormat.length - 1" :key="oindex"></v-divider>
            </template>
          </template>

          <div>
            <v-layout v-if="order.total != null">
              <v-flex>
                <div class="pa-2">{{ $t('Subtotal') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color"
                    >฿{{
                      (order.total - (order.shippingcharge ? order.shippingcharge : 0))
                        | decimalFormat
                    }}</span
                  >
                </div>
              </v-flex>
            </v-layout>
            <v-layout v-if="order.shippingcharge != null">
              <v-flex>
                <div class="pa-2">{{ $t('Shipping fee') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">฿{{ order.shippingcharge | decimalFormat }}</span>
                </div>
              </v-flex>
            </v-layout>
            <v-layout v-if="order.discount > 0">
              <v-flex>
                <div class="pa-2">{{ $t('Discount') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">-฿{{ order.discount | decimalFormat }}</span>
                </div>
              </v-flex>
            </v-layout>

            <v-layout v-if="jsonValue != null && jsonValue.promocode">
              <v-flex>
                <div class="pa-2">{{ $t('Coupon Code') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">{{ jsonValue.promocode }}</span>
                </div>
              </v-flex>
            </v-layout>

            <v-layout v-if="order.amount != null">
              <v-flex>
                <div class="pa-2">{{ $t('Total') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">฿{{ order.amount | decimalFormat }}</span>
                </div>
              </v-flex>
            </v-layout>
          </div>
          <v-divider />

          <v-layout>
            <v-flex class="pa-2">
              <img
                v-if="shippingType == 'normal'"
                src="/static/img/assets/payment/normal_charge_logo.png"
                alt
                class="responsive-img"
                style="max-height: 50px"
              />
              <img
                v-else-if="shippingType == 'ems'"
                src="/static/img/assets/payment/ems_charge_logo.png"
                alt
                class="responsive-img"
                style="max-height: 50px"
              />
              <img
                v-else-if="shippingType == 'kerry'"
                src="/static/img/assets/payment/kerry_charge_logo.png"
                alt
                class="responsive-img"
                style="max-height: 50px"
              />
              <template v-else>
                <template v-if="shippingType">
                  <img
                    @error="onImageLoadFailure($event)"
                    :src="'/static/img/assets/payment/' + shippingType + '_logo.png'"
                    alt
                    class="responsive-img"
                    style="max-height: 50px"
                  />
                  <div v-if="shippingType == 'cod_charge'" class="caption">
                    {{ $t('cod_charge') }}
                  </div>
                </template>
              </template>
            </v-flex>
            <v-flex class="pa-2 text-xs-right">
              <multiselect
                v-model="shippingValue"
                :options="shippingOptions"
                label="name"
                selectLabel
                selectedLabel
                :allow-empty="false"
                :searchable="false"
                deselect-label
                track-by="name"
                @select="onSelectShipping"
              >
                <template slot="singleLabel" slot-scope="props">
                  <span class="option__title">
                    <template v-if="props.option.name && props.option.name.includes('other')">{{
                      props.option[4]
                    }}</template>
                    <template v-else>{{ $t(props.option.name) }}</template>
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <div>
                    <span class="option__title">
                      <template v-if="props.option.name && props.option.name.includes('other')">{{
                        props.option[4]
                      }}</template>
                      <template v-else>{{ $t(props.option.name) }}</template>
                    </span>
                  </div>
                </template>
              </multiselect>
              <!-- <v-layout justify-center align-center style="height: 100%" row>
                <v-flex>
                  <template v-if="shippingType.includes('other')">{{ shippingValue }}</template>
                  <template v-else>{{ $t(shippingType) }}</template>
                </v-flex>
              </v-layout> -->
            </v-flex>
          </v-layout>
          <v-divider />
          <v-layout>
            <v-flex class="pa-2">
              <div class="caption">
                <template v-if="$store.state.centralPage.includes(selectedBot.pageid)"
                  >หมายเลขเดอะวัน</template
                >
                <template v-else>{{ $t('Remark') }}</template>
              </div>
              <editable
                v-model="order.remark"
                :filter="'text'"
                :type="'text'"
                @edited="$emit('updateOrder', 'save')"
              ></editable>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <v-flex xs12 sm5>
        <div style="word-break: break-word" class="pa-2">
          <a target="_BLANK" :href="`https://business.facebook.com${order.inboxurl}`"
            >{{ order.first_name }} {{ order.last_name }}</a
          >

          <template
            v-if="
              selectedBot.pageid == '103012211224246' ||
              selectedBot.pageid == '635426456938760' ||
              selectedBot.pageid == '613259679129221' ||
              selectedBot.pageid == '101857778024677'
            "
          >
            <template v-if="typeof shippingAddressPosition == 'string'">
              <edit-address
                v-model="order.nameaddress"
                :hasCopy="true"
                @edited="$emit('updateOrder', 'save')"
              ></edit-address>
            </template>
            <template v-else>
              <a
                :href="`https://maps.google.com?q=${shippingAddressPosition.lat},${shippingAddressPosition.lng}`"
                target="_blank"
                style="word-break: break-word"
              >
                https://maps.google.com?q={{
                  `${shippingAddressPosition.lat},${shippingAddressPosition.lng}`
                }}
              </a>
            </template>
          </template>
          <template v-else>
            <edit-address
              v-model="order.nameaddress"
              :type="'textarea'"
              @edited="$emit('updateOrder', 'save')"
              :hasCopy="true"
            ></edit-address>
          </template>
          <div class="caption mt-3">{{ $t('Status') }}</div>
          <div class="primary--text">{{ order.userstatus ? order.userstatus : '-' }}</div>
          <template v-if="$store.state.centralPage.includes(selectedBot.pageid)">
            <div class="caption mt-3">{{ $t('Live name') }}</div>
            <div class="primary--text">{{ order.livename ? order.livename : '-' }}</div>
          </template>
          <div class="caption mt-3">{{ $t('Tag') }}</div>
          <template v-if="tags.length > 0">
            <v-chip
              small
              v-for="(tag, index) in tags"
              :key="'tag_' + index"
              outline
              color="primary"
              disabled
              >{{ tag }}</v-chip
            >
          </template>
          <template v-else>
            <div class="primary--text">-</div>
          </template>
        </div>
        <v-divider></v-divider>

        <div class="pa-2" v-if="['booking', 'confirm'].includes(order.shippop_status)">
          <v-layout>
            <v-flex>สถานะการส่งกับ Shippop</v-flex>
            <v-flex shrink class="text-xs-right">
              <v-chip color="blue" disabled class="white--text" small>
                {{ order.shippop_status }}
              </v-chip>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex shrink> Shippop Tracking no. </v-flex>
            <v-flex class="text-xs-right">
              <a
                :href="`https://www.shippop.com/tracking/?tracking_code=${order.shippop_tracking_code}`"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ order.shippop_tracking_code }}
              </a>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex shrink>
              {{ $t('Tracking') }}
            </v-flex>
            <v-flex class="text-xs-right">
              {{ order.trackingno }}
            </v-flex>
          </v-layout>
        </div>

        <div class="pa-2" v-else>
          <multiselect
            v-model="status"
            :options="orderStatusOptions"
            label="label"
            :allow-empty="false"
            :searchable="false"
            selectLabel
            selectedLabel
            deselect-label
            track-by="label"
            @select="onSelectOrderStatus"
          ></multiselect>

          <template v-if="order.status == 'shipped'">
            <div class="form-control pt-2">
              <textarea
                type="text"
                v-model="order.trackingno"
                class="form-control"
                :placeholder="$t('Tracking')"
                maxlength="2000"
              />
            </div>
            <div class="text-xs-center text-sm-right mb-3">
              <v-btn
                outline
                color="primary"
                class="ma-0"
                small
                @click="$emit('updateOrder', 'save')"
                :disabled="
                  order.trackingno == null ||
                  order.trackingno == '' ||
                  order.trackingno.trim() == ''
                "
              >
                <i class="far fa-save"></i>
                &nbsp;
                {{ $t('Save') }}
              </v-btn>
              <v-btn
                outline
                color="primary"
                class="ma-0"
                small
                @click="$emit('updateOrder', 'send')"
                :disabled="
                  order.trackingno == null ||
                  order.trackingno == '' ||
                  order.trackingno.trim() == ''
                "
              >
                <i class="far fa-share-square"></i>
                &nbsp;
                {{ $t('Send') }}
              </v-btn>
            </div>
          </template>
          <template v-else-if="order.status == 'canceled'">
            <div class="form-control pt-2">
              <input
                type="text"
                v-model="order.reason"
                class="form-control"
                :placeholder="$t('Reason')"
                maxlength="300"
              />
            </div>
            <div class="text-xs-center text-sm-right mb-3">
              <v-btn
                outline
                color="primary"
                class="ma-0"
                small
                @click="$emit('updateOrder', 'save')"
                :disabled="order.reason == null || order.reason == '' || order.reason.trim() == ''"
              >
                <i class="far fa-save"></i>
                &nbsp;
                {{ $t('Save') }}
              </v-btn>
              <v-btn
                outline
                color="primary"
                class="ma-0"
                small
                @click="$emit('updateOrder', 'send')"
                :disabled="order.reason == null || order.reason == '' || order.reason.trim() == ''"
              >
                <i class="far fa-share-square"></i>
                &nbsp;
                {{ $t('Send') }}
              </v-btn>
            </div>
          </template>
          <template v-else>{{ order.trackingno }}</template>
        </div>

        <v-layout>
          <v-flex>
            <div class="pa-2">
              <div>
                <template v-if="shippingType && shippingType == 'cod_charge'">
                  {{ $t('cod_charge') }}
                </template>
                <template v-else>
                  <template v-if="order.payment == 'banktransfer' || order.payment == 'transfer'">
                    {{ $t('Bank Transfer') }}
                  </template>
                  <template v-else-if="order.payment == 'cod'">{{ $t('cod_charge') }}</template>
                  <template v-else-if="order.payment == 'qrcode'">Qr Code</template>
                  <template v-else-if="order.payment == 'fbpay'">
                    {{ $t('Mobile Banking') }}
                  </template>
                  <template v-else-if="order.payment == 'credit'">{{ $t('PayPal') }}</template>
                  <template v-else-if="order.payment == 'gbcredit'">{{
                    $t('Credit card')
                  }}</template>
                  <template v-else
                    >{{ order.payment }}
                    <span v-if="order.payment == '2c2p' && order.jsonvalue">
                      {{
                        ': ' +
                        (JSON.parse(order.jsonvalue).payment_channel
                          ? JSON.parse(order.jsonvalue).payment_channel
                          : '-')
                      }}
                    </span>
                  </template>
                </template>
                <div class="caption" v-if="order.transactionid">{{ $t(order.transactionid) }}</div>
              </div>
              {{ order.timestamp | moment('DD/MM/YYYY HH:mm') }}
            </div>
          </v-flex>
          <v-flex>
            <div class="pa-2">
              <div style="text-align: right">
                <print-all-covers
                  :orders="[order]"
                  :circle="true"
                  style="display: inline-block"
                ></print-all-covers>
                <PrintAllCoversCentral
                  v-if="$store.state.centralPage.includes(selectedBot.pageid)"
                  :orders="[order]"
                  :circle="true"
                  @onPrinCover="onPrinCover(true, $event)"
                  style="display: inline-block"
                ></PrintAllCoversCentral>
                <print-all-covers
                  v-else
                  :orders="[order]"
                  :circle="true"
                  @onPrinCover="onPrinCover(false, $event)"
                  style="display: inline-block"
                ></print-all-covers>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <template v-if="order.note">
      <div class="hr"></div>
      <a href="javascript:void(0);" @click="showDetail = !showDetail" style="text-decoration: none">
        <div class="text-xs-center" style="margin: 10px auto">
          {{ $t('Click to view slip') }}
          <i
            class="fas"
            :class="{ 'fa-chevron-down': showDetail, 'fa-chevron-up': !showDetail }"
          ></i>
        </div>
      </a>
      <div
        v-show="showDetail"
        style="margin-bottom: 0; background: rgb(253, 253, 253); border-bottom-left-radius: 10px"
      >
        <template v-if="showDetail">
          <template v-if="order.note == 'base64'">
            <load-base64 :orderid="order.id" :key="'slip_' + order.id"></load-base64>
          </template>
          <template v-else-if="order.note">
            <editable
              v-model="order.note"
              :filter="'image'"
              :type="'image'"
              @edited="$emit('updateOrder', 'save')"
            ></editable>
          </template>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import mixin from './OrderSummaryItem.js'
import LoadBase64 from './LoadBase64'
import EditAddress from './EditAddress'
export default {
  mixins: [mixin],
  components: {
    'load-base64': LoadBase64,
    EditAddress: EditAddress,
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/SummaryItem.vue